module.exports = __webpack_public_path__ + "static/media/caitlin_trussell_resume.f0bb8c9b.pdf";